/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Err_Order_Not_DeliveredInputs */

const vi_einvoice_err_order_not_delivered = /** @type {(inputs: Einvoice_Err_Order_Not_DeliveredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chỉ phát hành hoặc đóng hóa đơn khi đơn hàng đã giao thành công.`)
};

/**

* @param {Einvoice_Err_Order_Not_DeliveredInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_err_order_not_delivered = /** @type {((inputs?: Einvoice_Err_Order_Not_DeliveredInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Err_Order_Not_DeliveredInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_err_order_not_delivered(inputs)
});